import React, { useState, useEffect } from 'react';
import './Testimonials.css';
import { FaQuoteLeft, FaStar, FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  const testimonials = [
    {
      id: 1,
      name: "Dr. Zubin",
      position: "Director",
      hospital: "Jacob's Hospital, Thoppumpady",
      image: "👨‍⚕️",
      rating: 5,
      text: "Grandis HIS is user-friendly, integrates seamlessly with our existing operations, and has drastically improved our workflow. Our staff spends less time on administrative tasks and more time focusing on patient care. We've noticed a significant reduction in wait times, and the patient satisfaction rate has increased because of the software's efficiency. We couldn't be happier with this solution!"
    },
    {
      id: 2,
      name: "Allabakshy",
      position: "Director",
      hospital: "Sevana Hospital, Pattambi",
      image: "👨‍💼",
      rating: 5,
      text: "The data migration process, which we were initially concerned, was handled seamlessly. The team ensured minimal downtime and maintained data integrity throughout the transition. We were especially impressed by the way they customized the system to fit our workflows and provide hands-on training for our staff."
    },
    {
      id: 3,
      name: "Muhammed Shyjal",
      position: "Assistant General Manager",
      hospital: "Arogya Group of Clinics and Hospital",
      image: "👨‍💼",
      rating: 5,
      text: "We've been using GRANDIS's hospital software for over a year now, and the level of service and support has been outstanding. Their team is always responsive, knowledgeable, and genuinely committed to helping us run our operations smoothly, That's why we are planning to install the software in our other branches also. Thanks for the support, and we hope you will keep up the excellent customer service."
    },
    {
      id: 4,
      name: "Dr Joseph Chalissery",
      position: "Consultant Dermatologist",
      hospital: "Chalissery clinic & Clinic C Skin & Hair",
      image: "👨‍⚕️",
      rating: 5,
      text: "I have been using Grandis Software in both our clinics, and it has significantly streamlined our workflow. From patient record management to appointment scheduling and billing, the platform is intuitive, fast, and reliable. The ability to access data securely from anywhere has improved both patient care and team efficiency. Our staff adapted quickly thanks to the user-friendly interface, and the support team has always been responsive to our needs. I highly recommend for any healthcare practice looking to improve organization, save time, and enhance patient satisfaction."
    },
    {
      id: 5,
      name: "Dr. Ram Gopal",
      position: "Director",
      hospital: "Sreekandapuram Hospital",
      image: "👨‍⚕️",
      rating: 5,
      text: "Grandis Software Solutions ensured a remarkably smooth migration from our old system. Their implementation engineer and onsite support personnel were incredibly knowledgeable and a true partner in the process. With the first phase completed successfully, we are confidently looking forward to the planning and implementation of the second phase."
    },
    {
      id: 6,
      name: "Dr. P. M. Mathai",
      position: "Managing Director",
      hospital: "PMM Hospital",
      image: "👨‍⚕️",
      rating: 5,
      text: "I would like to express my deepest gratitude for the excellent work and dedication your team has shown in implementing your software in my Hospital. I especially appreciated efficiency, and reliability of your platform. I look forward to continuing this successful partnership and exploring even more ways we can work together to enhance healthcare delivery through technology."
    },
    {
      id: 7,
      name: "Dr. Joseph P.M.",
      position: "Managing Partner",
      hospital: "PMM Hospital",
      image: "👨‍⚕️",
      rating: 5,
      text: "I extend my sincere gratitude to Grandis for the software implemented in my hospital. It has facilitated significant upgrades in my hospital, including paperless registration and integrations. As the partner of the hospital and a practicing doctor, I have found the Electronic Medical Records (EMR) system to be very user-friendly. Grandis has been very supportive; in the event of any issues arising, they check and resolve them within 24 hours. And new feature requests are implemented promptly."
    }
  ];

  useEffect(() => {
    let interval;
    if (isAutoPlaying) {
      interval = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % testimonials.length);
      }, 5000);
    }
    return () => clearInterval(interval);
  }, [isAutoPlaying, testimonials.length]);

  const goToPrevious = () => {
    setIsAutoPlaying(false);
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const goToNext = () => {
    setIsAutoPlaying(false);
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const goToSlide = (index) => {
    setIsAutoPlaying(false);
    setCurrentIndex(index);
  };

  return (
    <section className="testimonials section">
      <div className="container">
        <h2 className="section-title">What Our <span className="gradient-text">Clients Say</span></h2>
        <p className="section-subtitle">
          Trusted by leading healthcare facilities across the country
        </p>

        <div className="testimonials-carousel">
          <button className="carousel-button prev" onClick={goToPrevious} aria-label="Previous testimonial">
            <FaChevronLeft />
          </button>

          <div className="testimonials-wrapper">
            {testimonials.map((testimonial, index) => (
              <div
                key={testimonial.id}
                className={`testimonial-card ${
                  index === currentIndex ? 'active' : ''
                } ${index === (currentIndex - 1 + testimonials.length) % testimonials.length ? 'prev' : ''} ${
                  index === (currentIndex + 1) % testimonials.length ? 'next' : ''
                }`}
              >
                <div className="quote-icon">
                  <FaQuoteLeft />
                </div>
                
                <div className="testimonial-rating">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <FaStar key={i} />
                  ))}
                </div>

                <p className="testimonial-text">{testimonial.text}</p>

                <div className="testimonial-author">
                  <div className="author-avatar">{testimonial.image}</div>
                  <div className="author-info">
                    <h4>{testimonial.name}</h4>
                    <p className="author-position">{testimonial.position}</p>
                    <p className="author-hospital">{testimonial.hospital}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <button className="carousel-button next" onClick={goToNext} aria-label="Next testimonial">
            <FaChevronRight />
          </button>
        </div>

        <div className="carousel-dots">
          {testimonials.map((_, index) => (
            <button
              key={index}
              className={`dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
              aria-label={`Go to testimonial ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
